import React, { useState } from 'react'
import { Input, Form, stringToSlug, Button } from '@guillotinaweb/react-gmi'
import { LANGS, setLangs } from '../../consts'
import { useLocation } from 'wouter'

export function PackForm({ onSubmit }) {
  const [loading, setLoading] = useState(false)
  const [, navigate] = useLocation()
  const [id, setId] = useState('')
  const [ref, setRef] = useState('')
  const [name, setName] = useState(setLangs(''))

  async function submit() {
    setLoading(true)

    const state = {
      '@type': 'Producto',
      id,
      nombre: name.es,
      tipo: '/pk',
      referencia_pack: ref,
      nombres: LANGS.reduce(
        (o, lang) => ({
          ...o,
          [lang]: {
            nombre: name[lang],
          },
        }),
        {}
      ),
    }

    await onSubmit(state)
    setLoading(false)
    navigate(`/?path=/packs/${id}/`)
  }

  return (
    <Form onSubmit={submit}>
      <h1 className="title is-size-4 has-text-primary">Add new Pack</h1>

      <Input
        id="name"
        required
        placeholder="Name"
        value={name.es}
        onChange={(n) => setName(setLangs(n))}
      />

      <Input
        id="Grupo"
        required
        placeholder="Grupo"
        value={id}
        onChange={(n) => setId(stringToSlug(n))}
      />

      <Input
        id="Pack reference (id_producto)"
        required
        maxLength={7}
        placeholder="Pack reference (id_producto)"
        value={ref}
        onChange={(n) => setRef(stringToSlug(n))}
      />
      <div style={{ marginTop: 20 }} className="level level-right">
        <Button disabled={loading} className="is-primary" loading={loading}>
          Create Pack
        </Button>
      </div>
    </Form>
  )
}
